import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';

import App from './App.vue';
import { router } from './router';
import { useAuthStore } from './stores/auth';
import { createHttpClient, setHttpClient } from './services/http';

import 'primeicons/primeicons.css';
import './assets/styles/main.scss';

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);

// Auth state needs to be hydrated *before* router guards run on the initial
// navigation, otherwise a logged-in user would be bounced to '/'.
const auth = useAuthStore();
auth.restoreFromStorage();

const apiBaseUrl = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');
const httpClient = createHttpClient({
  baseURL: `${apiBaseUrl}/api`,
  getToken: () => useAuthStore().token,
  onUnauthorized: () => {
    useAuthStore().logout();
    void router.push({ name: 'main' });
  },
});
setHttpClient(httpClient);

app.use(router);
app.use(PrimeVue, {
  theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } },
});
app.use(ToastService);
app.use(ConfirmationService);
app.use(DialogService);

app.mount('#app');
